import React from 'react';
import { NavLink } from 'react-router-dom';

const PasswordCrumb = () => <NavLink to="/profile/password">Change Password</NavLink>;

export default PasswordCrumb;
